import React from 'react';
import { ExtraData } from '../styles/common.styles';

const VerticalUncertainty = ({ altitudeUncertaintyRadius }) => {
  if (!altitudeUncertaintyRadius) return null;

  const value =
    altitudeUncertaintyRadius < 0
      ? `Unknown`
      : `${Number(altitudeUncertaintyRadius).toFixed(1)}m`;

  return (
    <ExtraData data-name="vertical-uncertainty">
      Vertical Uncertainty: {value}
    </ExtraData>
  );
};

export default VerticalUncertainty;
